/** Permission key for HealthLake medical record designation (confirm with BE/product if renamed). */
export const MEDICAL_RECORD_DESIGNATION_PERMISSION = 'medical_chronology';

export const MEDICAL_RECORD_PERMISSION_TOAST = "You don't have permission to designate medical records for this matter";

export const MEDICAL_RECORD_DEMOTE_CONFIRM_MESSAGE =
  "This will remove the document's FHIR resources from HealthLake. The original file in the document store is unaffected.";

export const PROMOTION_QUERY_KEY = 'doc-promotion-status';
